import store from "../store";
const langs = {
    'ru_RU': 'ru',
    'uk_UA': 'uk',
}
export default function langFilter(key) {
    const locale = store.getters.locale || 'uk_UA'
    return key[langs[locale]] || ''
}
